import React from 'react'

const PartnerFeature = () => {
    return (
        <section className="_feature_nft_wrapper">
            <div className="_feature_nft_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className="_feature_nft_head">
                                <h3 className="_feature_nft_head_txt">why partner
                                    with all blocks</h3>
                                <p className="_feature_nft_head_para">It is a long established
                                    fact that a reader will be distracted by the
                                    readable content of a page when looking at its layout.
                                    The point of </p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="_feature_nft_card">
                                <div className="_feature_nft_card_cont">
                                    <h6 className="_feature_nft_card_cont_txt">Generate Revenue</h6>
                                    <p className="_feature_nft_card_cont_para">With millions in transactions since 2017,
                                        we’ll help you generate revenue on our platform ⁠— from
                                        direct sales to secondary sales</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="_feature_nft_card">
                                <div className="_feature_nft_card_cont">
                                    <h6 className="_feature_nft_card_cont_txt">Reach Millions</h6>
                                    <p className="_feature_nft_card_cont_para">With over thousands of users
                                        and followers, we can help you reach a large audience of
                                        collectors</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="_feature_nft_card">
                                <div className="_feature_nft_card_cont">
                                    <h6 className="_feature_nft_card_cont_txt">Spend Less</h6>
                                    <p className="_feature_nft_card_cont_para">Compared with other NFT marketplaces,
                                        we have lowest fees in the space allowing you to spend
                                        less with your created collection</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="_feature_nft_card">
                                <div className="_feature_nft_card_cont">
                                    <h6 className="_feature_nft_card_cont_txt">Gas-free Marketplace</h6>
                                    <p className="_feature_nft_card_cont_para">With our multiple blockchains
                                        support, create, buy, and sell NFTs without paying
                                        any gas fee</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="_feature_nft_card">
                                <div className="_feature_nft_card_cont">
                                    <h6 className="_feature_nft_card_cont_txt">Robust Features</h6>
                                    <p className="_feature_nft_card_cont_para">With the most powerful
                                        way for users to buy and sell NFTS, we offer the most
                                        advanced features</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="_feature_nft_card">
                                <div className="_feature_nft_card_cont">
                                    <h6 className="_feature_nft_card_cont_txt">Breadth of Categories</h6>
                                    <p className="_feature_nft_card_cont_para">With over thousands of collections,
                                        we are proud to host the widest range of categories,
                                        ranging from digital to physical NFTs</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default PartnerFeature;